<template>
<div class="chapter">
<div class="inner_page">
<div class="Chapter_Page">
<h2 class="toc-head">Contents</h2>
<p class="toc"><a href="#/05_Chapter1" id="s1"><span class="space">1.</span>Q&amp;A</a></p>
<p class="toc"><span href="#/06_Chapter2" id="s2" title="Link target outside of Sample"><span class="space">2.</span>Dogs &amp; Cats</span></p>
<p class="toc"><span href="#/07_Chapter3" id="s3" title="Link target outside of Sample"><span class="space">3.</span>Yum Yuks!</span></p>
<p class="toc"><span href="#/08_Chapter4" id="s4" title="Link target outside of Sample"><span class="space">4.</span>Arrr!</span></p>
<p class="toc"><span href="#/09_Chapter5" id="s5" title="Link target outside of Sample"><span class="space">5.</span>Fairy Funny!</span></p>
<p class="toc"><span href="#/10_Chapter6" id="s6" title="Link target outside of Sample"><span class="space">6.</span>Knock-Knock!</span></p>
<p class="toc"><span href="#/11_Chapter7" id="s7" title="Link target outside of Sample"><span class="space">7.</span>Elephants</span></p>
<p class="toc"><span href="#/12_Chapter8" id="s8" title="Link target outside of Sample"><span class="space">8.</span>Humdingers</span></p>
<p class="toc"><span href="#/13_Chapter9" id="s9" title="Link target outside of Sample"><span class="space">9.</span>Space Case</span></p>
<p class="toc1"><span href="#/14_Chapter10" id="s10" title="Link target outside of Sample"><span class="space">10.</span>One-Liners</span></p>
<p class="toc1"><span href="#/15_Chapter11" id="s11" title="Link target outside of Sample"><span class="space">11.</span>Animal Antics</span></p>
<p class="toc1"><span href="#/17_Chapter12" id="s12" title="Link target outside of Sample"><span class="space">12.</span>’Snot Funny</span></p>
<p class="toc1"><span href="#/18_Chapter13" id="s13" title="Link target outside of Sample"><span class="space">13.</span>Who Farted?</span></p>
<p class="toc1"><span href="#/19_Chapter14" id="s14" title="Link target outside of Sample"><span class="space">14.</span>Br-a-a-ains!</span></p>
<p class="toc1"><span href="#/20_Chapter15" id="s15" title="Link target outside of Sample"><span class="space">15.</span>Real Stinkers</span></p>
<p class="toc1"><span href="#/21_Chapter16" id="s16" title="Link target outside of Sample"><span class="space">16.</span>Don’t Eat That!</span></p>
<p class="toc1"><span href="#/22_Chapter17" id="s17" title="Link target outside of Sample"><span class="space">17.</span>Creature Feature</span></p>
<p class="toc1"><span href="#/23_Chapter18" id="s18" title="Link target outside of Sample"><span class="space">18.</span>Yes We Cannibal</span></p>
<p class="toc1"><span href="#/24_Chapter19" id="s19" title="Link target outside of Sample"><span class="space">19.</span>That’s Sick</span></p>
<p class="toc1"><span href="#/25_Chapter20" id="s20" title="Link target outside of Sample"><span class="space">20.</span>Monster Mash</span></p>
<p class="toc1"><span href="#/26_Chapter21" id="s21" title="Link target outside of Sample"><span class="space">21.</span>Last Gasp</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?73da2cb7